export const MY_REFERRALS = 'MY_REFERRALS';


